export function attachVersionPrinterToWindow() {
    console.log("[Ver] Version info:", getVersions());
}

function getVersions() {
    const envFilePath = typeof ENV_FILE_PATH !== 'undefined' ? ENV_FILE_PATH : '.env.development';
    const buildEnv = typeof BUILD_ENV !== 'undefined' ? BUILD_ENV : 'undefined';
    
    let cssVersions: string[] = [];
    let agnosticVersion: string | null = null;
    let jsVersion: string | null = null;
    let externalScriptsLoaded: Record<string, boolean> = {};

    try {
        cssVersions = getCssVersions();
        agnosticVersion = extractAgnosticVersion(cssVersions);

        if (agnosticVersion) {
            cssVersions = cssVersions.filter(
                v => !v.toLowerCase().startsWith('agnostic:') &&
                     !v.toLowerCase().startsWith('agnostic')
            );
        }

        jsVersion = BUILD_VERSION; // Safe as long as DefinePlugin is used

        const domainsToCheck = [
            'convertexperiments.com',
            'here.com',
            'datadoghq-browser-agent.com'
        ];
        externalScriptsLoaded = getLoadedDomainsStatus(domainsToCheck);
    } catch (error) {
        console.error('[Ver] Failed to get version info:', error);
    }

    return {
        envFilePath,
        buildEnv,
        cssVersions,
        agnosticVersion,
        jsVersion,
        externalScriptsLoaded
    };
}


 function getCssVersions(): string[] {
    try {
        const versions: string[] = [];
        const text = document.documentElement.outerHTML;
        const styleExtractor = text.split(`<style id="required">`)[1]?.split(`</style>`)[0]?.split("\n");

        styleExtractor.forEach((line) => {
           const ver  = line.split("*/")[0]?.split("/*!*")[1]?.trim();
           if(ver){
            versions.push(ver.replace(" ", ": "));
           }
        });

        // Add agnostic version if found
        const agnosticVersion = getAgnosticVersion(text);
        if (agnosticVersion) {
            versions.push(agnosticVersion);
        }

        return versions;
    } catch (error) {
        console.error(`[Ver] Failed to extract assets from page`, error);
        return [];
    }
}

function getAgnosticVersion(html: string): string | null {
    const linkRegex = /<link[^>]+href=["'][^"']*scheduler\/index\.(\d+\.\d+\.\d+(?:-[a-zA-Z0-9-]*)?)\.js["'][^>]*>/g;
    const match = linkRegex.exec(html);
    return match?.[1] ? `Agnostic: ${match[1]}` : null;
}


function extractAgnosticVersion(cssVersions: string[]): string | null {
    const agnosticEntry = cssVersions.find(v => v.startsWith('Agnostic:'));
    if (agnosticEntry) {
        return agnosticEntry.slice('Agnostic:'.length).trim() || null;
    }
    return null;
}


function getLoadedDomainsStatus(domains: string[]): Record<string, boolean> {
    const entries = performance.getEntriesByType('resource') as PerformanceResourceTiming[];
  
    const result: Record<string, boolean> = {};
  
    for (const domain of domains) {
      result[domain] = entries.some(entry => entry.name.includes(domain));
    }
  
    return result;
}
  